export type MeasurementUnit = "metric" | "imperial";

export const MEASUREMENT_UNITS = {
  metric: {
    value: "metric" as const,
    numericValue: 1,
    label: "Metric (kg, cm)",
  },
  imperial: {
    value: "imperial" as const,
    numericValue: 2,
    label: "Imperial (lbs, in)",
  },
} as const;

export const MEASUREMENT_UNIT_OPTIONS = [
  MEASUREMENT_UNITS.metric,
  MEASUREMENT_UNITS.imperial,
];
